// removed by extract-text-webpack-plugin
module.exports = {"NotFoundPage":"_-3uRn0te","Section":"_2-xtu0mw","Image":"_6IclWg9C"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/not-found/not-found-page.styles.scss
// module id = 265
// module chunks = 0